import { isConsultantDeadlinesAssistantPage } from '@prospero/shared/src/assistant/assistant-contract';

export const NEAR_BOTTOM_THRESHOLD_PX = 80;

/** The consultant deadline tracker: same predicate as the backend capability (shared). */
export function isConsultantDeadlinesPage(pageUrl: string): boolean {
  return isConsultantDeadlinesAssistantPage(pageUrl);
}

/**
 * The HACCP manual draft page (/doc-generation/:templateId): the only page
 * whose starter chips are the manual copilot's. Must mirror the backend's
 * `isDocGenerationDraftRoute` in assistant-page-capabilities.ts.
 */
export function isDocGenerationDraftPage(pageUrl: string): boolean {
  return /^\/doc-generation\/[^/]+$/.test(pageUrl);
}

/**
 * The consultant survey studio builder page (/consultant/surveys/:templateId):
 * its starter chips are the survey authoring copilot's. Must mirror the
 * backend's `SURVEY_AUTHORING_ROUTE_RE` in assistant-page-capabilities.ts.
 */
export function isSurveyAuthoringPage(pageUrl: string): boolean {
  return /^\/consultant\/surveys\/[^/]+$/.test(pageUrl);
}

/** `m:ss` — bounded by the 120s auto-stop, no hours needed. */
export function formatRecordingTime(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

/**
 * The thread follows the newest message only when it actually grew or the
 * user was already reading at the bottom: a same-length refresh must never
 * yank someone away from the history they are reading. Null geometry (no
 * container yet) counts as "not near the bottom".
 */
export function shouldAutoScrollToEnd({
  distanceFromBottom,
  messageCount,
  previousMessageCount,
}: {
  distanceFromBottom: number | null;
  messageCount: number;
  previousMessageCount: number;
}): boolean {
  if (messageCount > previousMessageCount) {
    return true;
  }
  return distanceFromBottom !== null && distanceFromBottom <= NEAR_BOTTOM_THRESHOLD_PX;
}
